const DATE_TYPES = {
    long: 'long',
};

export default DATE_TYPES;
